import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IconButton, PersonListIcon, Select, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { getTeamsByIds, getVisibleTeamIds } from "~/store/selectors/selector.teams";
import { TeamOption } from "./TeamOption";

export const getValidMembers = (members, ids) => {
  const validMembers = members.filter((member) => ids.includes(member));
  return validMembers;
};

export const TeamPicker = ({ onChange, selected, ids }) => {
  const { t } = useTranslation();

  const teamIds = useSelector(getVisibleTeamIds);
  const teams = useSelector((state) => getTeamsByIds(state, teamIds));

  const options = [
    { id: "everyone", name: t("Everyone"), members: ids },
    ...teams
      .filter((team) => getValidMembers(team.members, ids).length > 0)
      .sort((a, b) => a.name.localeCompare(b.name)),
  ];

  const renderOption = useCallback(
    (item) => (
      <TeamOption
        name={item.name}
        onClick={onChange}
        selected={selected}
        members={item.members}
        ids={ids}
        hideAvailable={item.id === "everyone"}
      />
    ),
    [ids, selected, onChange]
  );

  if (options.length <= 1) return null;

  return (
    <Select
      type="multiple"
      options={options}
      keepSameOptionsOrder
      disabledInternalSort
      autoHeightMax={227}
      disableSearch={options.length < 7}
      noResultText={t("No Result")}
      renderOption={renderOption}
      target={
        <div>
          <Tooltip title={t("Select Teams")}>
            <IconButton variant="text gray">
              <PersonListIcon />
            </IconButton>
          </Tooltip>
        </div>
      }
    />
  );
};

TeamPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
};
